import { render, staticRenderFns } from "./LMSSettingsModal.vue?vue&type=template&id=089853f2&"
import script from "./LMSSettingsModal.vue?vue&type=script&lang=js&"
export * from "./LMSSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports